import * as React from "react"
import ChartType from "../../../enums/ChartType"
import { DatetimeSelector } from "../../Reusable/DatetimeSelector"
import { LocationListing } from "../../Reusable/LocationListing"
import { LocationSelector } from "../../Reusable/LocationSelector"
import { BuyButton } from "./BuyButton"


export function Index() {
  return (
    <div className="d-flex flex-column text-center">
      <h1 id="title">P+Rail Location Forecast</h1>
      <LocationSelector chartType={ChartType.DAILY}/>
      <DatetimeSelector/>
      <LocationListing/>
      <BuyButton/>
    </div>
  )
}
